export default {
  common: {
    ageConfirmed: "21+",
    brandZone: "PARK LIVE • БРЕНД-АЙМАҚ",
    brandTitle: "ABSOLUT TABASCO",
    brandCollab: "PARK LIVE × ABSOLUT TABASCO",
    close: "Жабу",
    retry: "Қайта көру",
    loading: "Жүктелуде...",
    newParticipant: "Жаңа қатысушы"
  },
  desktopStub: {
    title: "Тек мобильді нұсқада қолжетімді",
    subtitle: "Бұл бетті смартфоныңыздан ашыңыз немесе браузерді мобильді құрылғы режиміне ауыстырыңыз."
  },
  ageConfirm: {
    title: "Туған күніңізді енгізіңіз",
    placeholderDay: "кк",
    placeholderMonth: "аа",
    placeholderYear: "жжжж",
    confirmBtn: "Растаймын",
    errors: {
      underage: "Жалғастыру үшін 21 жасқа толуыңыз керек.",
      fillAll: "Күн, ай және жылды толық енгізіңіз",
      invalidDay: "Күнді дұрыс енгізіңіз (01-31).",
      invalidMonth: "Айды дұрыс енгізіңіз (01-12).",
      invalidYear: "Туған жылыңызды дұрыс енгізіңіз.",
      invalidDate: "Күнді дұрыс енгізіңіз."
    }
  },
  otp: {
    title: "кодты енгізіңіз",
    description: "Нөміріңізге код жіберілді, жалғастыру үшін кодты енгізіңіз",
    errorWrongCode: "код қате енгізілді",
    alreadyRegistered: "Сіз тіркеліп қойғансыз",
    resendPrefix: "SMS-ті қайта жіберу {sec} сек. кейін қолжетімді",
    resendBtn: "SMS-ті қайта жіберу",
    confirmBtn: "Растау",
    sendingBtn: "Жіберілуде...",
    successText: "Тіркелу сәтті аяқталды"
  },
  screen1: {
    headerLeft: "PARK LIVE · БРЕНД-АЙМАҒЫ",
    subHeader: "PARK LIVE × ABSOLUT TABASCO",
    titleLine1: "ABSOLUT",
    titleLine2: "TABASCO",
    instruction: "ФОРМАНЫ ТОЛТЫР, ДӨҢГЕЛЕКТІ АЙНАЛДЫР ЖӘНЕ СЫЙЛЫҚТАРЫҢДЫ АЛ!",
    participateBtn: "ҚАТЫСУ",
    disclaimer: "«Қатысу» батырмасын басу арқылы сіз 21 жасқа толғаныңызды растайсыз."
  },
  screen2: {
    stepHeaderLeft: "1-ҚАДАМ / 2 · ТІРКЕЛУ",
    stepHeaderRight: "ABSOLUT TABASCO",
    subtitle: "АЗ ҚАЛДЫ",
    heading: "ФОРМАНЫ ТОЛТЫР",
    formError: "Форманы жүктеу қатесі. Кейінірек көріңіз.",
    disclaimer: "Барлық өрістер мен келісімдер қатысу үшін міндетті түрде толтырылуы тиіс.",
    submitBtn: "СӘТТІЛІК ДӨҢГЕЛЕГІНЕ",
    sendingBtn: "ЖІБЕРІЛУДЕ...",
    placeholders: {
      fullName: "Аты-жөні",
      name: "Аты",
      surname: "Тегі",
      city: "Қала",
      gender: "Жынысы",
      email: "Email",
      select: "Нұсқаны таңдаңыз",
      login: "Логинді енгізіңіз",
      phone: "+7 (___) ___-__-__"
    },
    gender: {
      label: "Жынысы",
      male: "Ер",
      female: "Әйел"
    },
    phoneLabel: "Телефон нөмірі",
    consent: {
      personalDataPrefix: "Мен келісім беремін:",
      personalDataLink: "дербес деректерді жинауға және өңдеуге",
      rulesPrefix: "Мен келісемін:",
      rulesLink: "қатысу ережелерімен",
      marketing: "Менің деректерімді брендтің маркетингтік белсенділіктерінде пайдалануға және жарнамалық хабарламалар алуға келісемін."
    },
    errors: {
      required: "Өріс міндетті",
      consentRequired: "Шарттарды қабылдауыңыз керек.",
      lettersOnly: "Тек әріптер жазуға болады.",
      invalidEmail: "Дұрыс email енгізіңіз.",
      invalidPhone: "Дұрыс телефон нөмірін енгізіңіз.",
      fillAllFields: "Барлық өрістерді толтырыңыз",
      fixErrors: "Жіберу алдында қателерді түзетіңіз",
      enterFullName: "Аты-жөніңізді енгізіңіз",
      consentNeeded: "Қатысу үшін келісімдерді қабылдау қажет",
      invalidCode: "Код қате енгізілді",
      sendCodeError: "Код жіберу қатесі. Қайта көріңіз.",
      botDetected: "Бот күдігі. Бетті қайта жүктеңіз."
    }
  },
  screen3: {
    stepHeaderLeft: "2-ҚАДАМ / 2 · ҰТЫС ОЙЫНЫ",
    stepHeaderRight: "ABSOLUT TABASCO",
    title: "ДӨҢГЕЛЕКТІ АЙНАЛДЫР",
    disclaimer: "БІР НӨМІРМЕН – БІР РЕТ ҚАТЫСУ. СӘТТІЛІК ТІЛЕЙМІЗ",
    spinBtn: "АЙНАЛДЫРУ",
    spinningBtn: "АЙНАЛУДА...",
    badge: "SPIN"
  },
  screen4: {
    stepHeaderLeft: "СЕНІҢ НӘТИЖЕҢ",
    stepHeaderRight: "ABSOLUT TABASCO",
    physicalInstruction: "Сыйлықты алу үшін бұл экранды бренд-аймақ қызметкеріне көрсетіңіз.",
    promoHeader: "xo.kz сайтындағы промокод",
    promoInstruction: "Промокодты суретке түсір.",
    promoExpiryPrefix: "Промокодты пайдаланыңыз:",
    promoExpiryUntil: "{date} дейін.",
    promoExpiryDefaultDate: "30 қыркүйекке",
    qrCaption: "Сатып алу үшін QR кодты сканерле",
    partnerBtn: "XO.KZ САЙТЫНА ӨТУ",
    copyBtn: "Көшіру",
    copiedBtn: "КӨШІРІЛДІ!",
    nextParticipantBtn: "КЕЛЕСІ ҚАТЫСУШЫ",
    nextParticipantSubtitle: "Келесі қатысушыны тіркеуді бастау"
  },
  prizes: {
    fan: {
      name: "Желдеткіш",
      sectorText: "ЖЕЛДЕТКІШ",
      title: "ЫҚШАМ ЖЕЛДЕТКІШ",
      subtitle: "ыстық күндерде салқындау үшін"
    },
    visor: {
      name: "Күнкепка",
      sectorText: "КҮНКЕПКА",
      title: "БРЕНДТІК КҮНКЕПКА",
      subtitle: "фестивальге арналған стильді аксессуар"
    },
    blanket: {
      name: "Плед",
      sectorText: "ПЛЕД",
      title: "ЖАЙЛЫ ПЛЕД",
      subtitle: "фирмалық брендингтік плед"
    },
    bag: {
      name: "Сөмке",
      sectorText: "СӨМКЕ",
      title: "БРЕНДТІК СӨМКЕ",
      subtitle: "ыңғайлы әрі стильді сөмке"
    },
    promocode: {
      name: "Промокод",
      sectorText: "-20%",
      title: "20% ЖЕҢІЛДІК",
      subtitle: "XO.kz сайтында сатып алуға"
    },
    defaultPhysicalTitle: "ЗАТТАЙ СЫЙЛЫҚ"
  },
  legal: {
    policy: {
      title: "Құпиялылық саясаты",
      content: `<b>Pernod Ricard Kazakhstan,</b> дербес деректер операторы ретінде веб-сайтты пайдалану кезінде сіздің құпиялылық құқығыңызды құрметтейді.
Осы Құпиялылық саясатының мақсаты — Pernod Ricard Kazakhstan компаниясы веб-сайт арқылы берілген дербес деректеріңізді қалай жинайтыны, сақтайтыны және өңдейтіні туралы ақпарат беру.

<b>1. Біз қандай дербес деректерді жинаймыз?</b>
 Аты, тегі
 Туған күні
 Телефон нөмірі
 Электрондық пошта мекенжайы
 Тұратын қаласы

<b>2. Деректер қандай мақсатта пайдаланылады?</b>
 Промо-акциялар мен ұтыс ойындарына қатысуды қамтамасыз ету.
 Жас шектеуіне сәйкестікті тексеру (21+).
 Әкімшілік хабарламалар мен ұтыс туралы ақпарат жіберу.
 Маркетингтік ұсыныстар жіберу (келісім болған жағдайда).`
    },
    offer: {
      title: "ДЕРБЕС ДЕРЕКТЕРДІ ЖИНАУҒА ЖӘНЕ ӨҢДЕУГЕ КЕЛІСІМ",
      content: `Мен 21 жасқа толғанымды растаймын және <b>«Перно Рикар Казахстан» ЖШС-не (БСН 050840001045),</b> сондай-ақ олардың қызметкерлеріне менің дербес деректерімді жинауға, өңдеуге және трансшекаралық беруге <b>келісімімді беремін:</b>
1) Аты-жөні
2) Туған күні
3) Ұялы телефон
4) E-mail
5) Тұратын қаласы

<b>Мақсаты:</b> «Перно Рикар Казахстан» ЖШС өнімдерінің маркетингтік белсенділіктері мен сыйлық ұтыстарына қатысу.
Ақпараттық және жарнамалық хабарламаларды (соның ішінде SMS және мессенджерлер) алуға келісемін.`
    },
    rules: {
      title: "БЕЛСЕНДІЛІКТІ ӨТКІЗУ ШАРТТАРЫ",
      content: `<b>1. Жалпы ережелер</b>
1.1. Осы Шарттар «Absolut Tabasco Сәттілік Дөңгелегі» белсенділігін өткізу тәртібін анықтайды.
1.2. Ұйымдастырушы: «Pernod Ricard Kazakhstan» ЖШС.
1.3. Белсенділік лотерея болып табылмайды.

<b>2. Қатысушылар</b>
2.1. 21 жасқа толған әрекетке қабілетті жеке тұлғалар қатыса алады.
2.2. Бір қатысушы бір сыйлықтан артық ала алмайды.

<b>3. Қатысу және сыйлықтарды алу тәртібі</b>
3.1. Жасты растау, тіркелу формасын толтыру, нөмірді OTP арқылы растау және Сәттілік дөңгелегін айналдыру қажет.
3.2. Заттай сыйлықтар бренд-аймақта нәтиже экранын көрсеткен кезде беріледі.`
    }
  },
  unsubscribe: {
    title: "Бас тартқыңыз келетін байланыс түрін таңдаңыз:",
    doNotBulkEmail: "E-mail арқылы жаппай жарнамалық және ақпараттық хабарламаларды алмау",
    doNotEmail: "E-mail арқылы жеке хабарламаларды алмау",
    doNotSendMm: "SMS, телефон және E-mail қоса, барлық байланыс арналары бойынша хабарламаларды алмау.",
    submitBtn: "ЖАЗЫЛУДАН БАС ТАРТУ",
    savingBtn: "САҚТАЛУДА...",
    successMessage: "Баптауларыңыз сәтті сақталды",
    errorMessage: "Сақтау кезінде қате орын алды.",
    loadErrorTitle: "Деректерді жүктеу кезінде қате орын алды",
    loadErrorText: "Баптауларыңызды алу мүмкін болмады. Бетті кейінірек жаңартып көріңіз.",
    userNotFound: "Пайдаланушы табылмады немесе сілтеменің мерзімі өткен."
  }
};
